import axios from "axios";

export default function UserCompanyDeleteService(userId, companyId) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/user/" + userId + "/companies/"  + companyId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
